import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import Header from './layout/header';
import Sidebar from './layout/sidebar';
import { AuthProvider } from './context/AuthContext';
import { BrowserRouter } from 'react-router-dom';
import SessionExpiryChecker from './helpers/SessionExpiryChecker';
import './i18n';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <React.StrictMode>
    <head>
      <title>TravelCare Backoffice</title>
      <meta name="description" content="TravelCare Backoffice" />
      <meta name="keywords" content="TravelCare Backoffice" />
      <meta name="author" content="TravelCare" />
      <meta name="viewport" content="width=device-width, initial-scale=1.0" />
    </head>
    <AuthProvider>
      <BrowserRouter>
        <div className="websiteContainer">
          <SessionExpiryChecker />
          <Header />
          <Sidebar />
          <App />
        </div>
      </BrowserRouter>
    </AuthProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
